<template>
  <div class="q-wrap">
    <div class="q-row">
      <label class="q-label">Texto de la pregunta</label>
      <input class="q-input" :class="{ 'q-input--error': question.error }" type="text"
        placeholder="Escribe la pregunta aquí..." v-model="question.texto" />
      <p v-if="question.error" class="q-error-msg">Ingrese la pregunta.</p>
    </div>

    <div class="q-row">
      <label class="q-label">Descripción <span>(opcional)</span></label>
      <textarea class="q-input" type="text" placeholder="Describe lo que se espera en la respuesta..." v-model="question.descripcion" ></textarea>
    </div>

    <div class="q-row">
      <label class="q-label">Nota <span>(opcional)</span></label>
      <input class="q-input" type="text" placeholder="Escribe una nota corta o definición..." v-model="question.nota_para_registrante" />
    </div>

    <div class="q-row">
      <div class="q-options-header">
        <span class="q-label m-0">Campos de matriz</span> 
        <label class="q-check-row ml-auto">
          <input type="checkbox" v-model="question.obligatoria" />
          <span>Obligatoria</span>
        </label>
      </div>
    </div>

    <!-- Columnas -->
    <div class="q-row my-2">
      <div class="q-options-header">
        <span class="q-label" style="margin:0">Columnas</span>
        <button type="button" class="q-add-btn" @click="addColumna">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
          Agregar columna
        </button>
        <p v-if="question.columnaError" class="q-error-msg">Deben llenarse todas las columnas.</p>
        <p v-if="question.maximumColumnaError" class="q-error-msg">Maximo {{ maxOptions }} columnas.</p>
      </div>
      <div class="q-grid">
        <div v-for="(columna, index) in question.columnas" :key="'c'+index" class="q-chip-item">
          <input class="q-input" :class="{ 'q-input--error': columna === '' && question.columnaError }"
            type="text" :placeholder="'Col. ' + (index + 1)" v-model="question.columnas[index]" />
          <button v-if="question.columnas.length > 2" type="button" class="q-chip-del" @click="removeColumna(index)" title="Eliminar">×</button>
        </div>
      </div>
    </div>

    <!-- Filas -->
    <div class="q-row">
      <div class="q-options-header">
        <span class="q-label m-0">Filas</span>
        <button type="button" class="q-add-btn" @click="addFila">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/></svg>
          Agregar fila
        </button>
        <p v-if="question.filaError" class="q-error-msg">Deben llenarse todas las filas.</p>
        <p v-if="question.maximumFilaError" class="q-error-msg">Maximo {{ maxOptions }} filas.</p>
        
      </div>
      <div class="q-grid">
        <div v-for="(fila, index) in question.filas" :key="'f'+index" class="q-chip-item">
          <input class="q-input" :class="{ 'q-input--error': fila === '' && question.filaError }"
            type="text" :placeholder="'Fila ' + (index + 1)" v-model="question.filas[index]" />
          <button v-if="question.filas.length > 1" type="button" class="q-chip-del" @click="removeFila(index)" title="Eliminar">×</button>
        </div>
      </div>
    </div>
    <div class="q-row">
      <label class="q-check-row">
        <input type="checkbox" v-model="question.otro" />
        <span>Incluir fila "Otro" (opcional para el registrante)</span>
      </label>
      <div v-if="question.otro" class="q-otro-type-row">
        <label class="q-label">Tipo de dato de la fila "Otro"</label>
        <select class="q-input q-input--select" v-model="question.tipo_otro">
          <option value="texto">Texto</option>
          <option value="numero">Número</option>
          <option value="fecha">Fecha</option>
          <option value="hora">Hora</option>
        </select>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "matrix-question",
  data() {
    return {
      maxOptions: 25
    };
  },
  mounted() {
    this.fetchConfiguration();
    if (!this.question.tipo_otro) this.$set(this.question, 'tipo_otro', 'texto');
  },
  methods: {
    fetchConfiguration() {
      this.axios.get("apidev/api/config/site").then(response => {
        if (response.data && response.data.config && typeof response.data.config.max_question_options === "number") {
          this.maxOptions = response.data.config.max_question_options;
        }
      }).catch(() => {});
    },
    remove() { this.$emit("click"); },
    addFila() {
      if (this.question.filas.length < this.maxOptions) {
        this.question.filas.push("");
        this.question.maximumFilaError = false;
      } else {
        this.question.maximumFilaError = true;
      }
    },
    removeFila(index) {
      if (this.question.filas.length > 1) {
        this.question.filas.splice(index, 1);
        this.question.maximumFilaError = false;
      }
    },
    addColumna() {
      if (this.question.columnas.length < this.maxOptions) {
        this.question.columnas.push("");
        this.question.maximumColumnaError = false;
      } else {
        this.question.maximumColumnaError = true;
      }
    },
    removeColumna(index) {
      if (this.question.columnas.length > 2) {
        this.question.columnas.splice(index, 1);
        this.question.maximumColumnaError = false;
      }
    },
    validateQuestion() {
      let valid = true;
      if (this.question.texto === "") { this.question.error = true; valid = false; } else { this.question.error = false; }
      if (this.question.filas.some(f => f === "")) { this.question.filaError = true; valid = false; } else { this.question.filaError = false; }
      if (this.question.columnas.some(c => c === "")) { this.question.columnaError = true; valid = false; } else { this.question.columnaError = false; }
      return valid;
    },
  },
  props: { question: { required: true } },
};
</script>

<style scoped>
.q-wrap { display: flex; flex-direction: column; gap: 12px; font-size: 0.82rem; }
.q-row { display: flex; flex-direction: column; gap: 4px; }
.q-label { font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.07em; color: #64748b; }
.q-hint { font-weight: 400; text-transform: none; color: #94a3b8; font-style: italic; }
.q-input { width: 100%; padding: 6px 10px; border: 1px solid #cbd5e1; border-radius: 7px; background: #f8fafc; color: #334155; font-size: 0.82rem; transition: border-color 0.15s, box-shadow 0.15s; outline: none; box-sizing: border-box; }
.q-input:focus { border-color: #3b82f6; box-shadow: 0 0 0 3px rgba(59,130,246,0.12); background: #fff; }
.q-input--error { border-color: #f87171 !important; }
.q-error-msg { font-size: 0.7rem; color: #ef4444; margin: 0; }
.q-check-row { display: flex; align-items: center; gap: 6px; }
.q-check-row input[type=checkbox] { width: 14px; height: 14px; accent-color: #3b82f6; cursor: pointer; }
.q-check-row span { font-size: 0.72rem; font-weight: 600; text-transform: uppercase; letter-spacing: 0.06em; color: #475569; }
.q-options-header { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.q-add-btn { display: inline-flex; align-items: center; gap: 4px; padding: 4px 10px; border: 1px solid #e2e8f0; border-radius: 6px; background: #f1f5f9; color: #475569; font-size: 0.72rem; font-weight: 600; cursor: pointer; transition: all 0.15s; }
.q-add-btn:hover { background: #e2e8f0; }
.q-add-btn svg { width: 12px; height: 12px; }
.q-input--select { width: auto; min-width: 120px; max-width: 200px; }
.q-otro-type-row { display: flex; flex-direction: column; gap: 4px; margin-left: 20px; margin-top: -4px; }
.q-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(120px, 1fr)); gap: 8px; }
.q-chip-item { position: relative; }
.q-chip-del { position: absolute; top: -7px; right: -7px; display: flex; align-items: center; justify-content: center; width: 18px; height: 18px; border-radius: 50%; background: #ef4444; color: #fff; border: none; cursor: pointer; font-size: 11px; line-height: 1; padding: 0; }
</style>
